"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCardList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var PaymentCardList = /** @class */ (function (_super) {
    __extends(PaymentCardList, _super);
    function PaymentCardList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.handelOnClick = _this.handelOnClick.bind(_this);
        return _this;
    }
    PaymentCardList.prototype.render = function () {
        var _this = this;
        var cards = [];
        var buttonPrefix = this.getSetting("buttonPrefix", "Pay with");
        if (this.props.interaction.policyHolder.cardDetails && this.props.interaction.agreeToReuseCardDetails) {
            var _loop_1 = function (cardDetails) {
                cards.push((0, jsx_runtime_1.jsx)("button", { className: "btn btn-primary btn-next plugin mt-0 mb-0 ml-3 ".concat(this_1.getSetting("cssClass", "")), onClick: function (event) { return _this.handelOnClick(event, cardDetails.number); }, id: "card-" + cardDetails.number, children: "".concat(buttonPrefix, " ").concat(cardDetails.number) }, cardDetails.number));
            };
            var this_1 = this;
            for (var _i = 0, _a = this.props.interaction.policyHolder.cardDetails; _i < _a.length; _i++) {
                var cardDetails = _a[_i];
                _loop_1(cardDetails);
            }
        }
        return cards;
    };
    PaymentCardList.prototype.handelOnClick = function (event, cardNumber) {
        var paymentDetails = this.props.engine.getInteraction().paymentDetails;
        paymentDetails.cardNumber = cardNumber;
        this.props.engine.callInteractionSetState(__assign(__assign({}, this.props.engine.getInteraction()), { paymentDetails: paymentDetails }));
        this.executeEvent('click');
        event.preventDefault();
    };
    PaymentCardList = __decorate([
        (0, journey_model_1.settings)([
            { name: "cssClass", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], PaymentCardList);
    return PaymentCardList;
}(plugin_journey_1.WidgetBase));
exports.PaymentCardList = PaymentCardList;
//# sourceMappingURL=PaymentCardList.js.map